/* unplugin-vue-components disabled */import { render } from "./science.vue?vue&type=template&id=04bd929a&scoped=true"
import script from "./science.vue?vue&type=script&lang=js"
export * from "./science.vue?vue&type=script&lang=js"

import "./science.vue?vue&type=style&index=0&id=04bd929a&lang=scss&scoped=true"
import "./science.vue?vue&type=style&index=1&id=04bd929a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bd929a"]])

export default __exports__